import React from "react";
import ReactDOM from "react-dom";

// https://reactjs.org/docs/portals.html
class Portal extends React.Component {

    constructor(props) {
        super(props);
        let p = this.props.portalId && document.getElementById(this.props.portalId);
        if (!p) {
            if (document.getElementById('portal')) {
                p = document.createElement('div');
                this.holder = document.getElementById('portal');
            } else {
                p = document.createElement('div');
                if (this.props.portalId) {
                    p.id = this.props.portalId;
                }
                this.holder = document.body;
            }
            this.holder.appendChild(p);
        }
        this.portalElement = p;
    }

    componentDidMount() {
        // The portal element is inserted in the DOM tree after
        // the Modal's children are mounted, meaning that children
        // will be mounted on a detached DOM node. If a child
        // component requires to be attached to the DOM tree
        // immediately when mounted, for example to measure a
        // DOM node, or uses 'autoFocus' in a descendant, add
        // state to Modal and only render the children when Modal
        // is inserted in the DOM tree.
        this.holder.appendChild(this.portalElement);
    }

    componentWillUnmount() {
        this.holder.removeChild(this.portalElement);
    }

    render() {
        return ReactDOM.createPortal(
            <div {...this.props}>{this.props.children}</div>,
            this.portalElement,
        );
    }

}

export default Portal;

/*
import React from "react";
import {render, createPortal} from "react-dom";

class Portal extends React.Component {
    render() {
        return createPortal(<div {...this.props}>{this.props.children}</div>, document.getElementById(this.props.portalId || 'portal'));
    }
}

export default Portal;
 */